// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flight-takeoff"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6.10495 4.01764L8.0368 3.5L14.7438 9.98507L20.2496 8.50981C21.0498 8.29539 21.8723 8.77027 22.0867 9.57047C22.3011 10.3707 21.8262 11.1932 21.026 11.4076L4.12233 15.9369L1.8623 11.3661L3.31119 10.9779L4.98794 12.5991L10.1073 11.2274L6.10495 4.01764Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.10495 4.01764L8.0368 3.5L14.7438 9.98507L20.2496 8.50981C21.0498 8.29539 21.8723 8.77027 22.0867 9.57047C22.3011 10.3707 21.8262 11.1932 21.026 11.4076L4.12233 15.9369L1.8623 11.3661L3.31119 10.9779L4.98794 12.5991L10.1073 11.2274L6.10495 4.01764Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 20H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FlightTakeoffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flight-takeoff',
    ref,
    icon: element,
  },
));

FlightTakeoffIcon.displayName = 'FlightTakeoffIcon';

export default FlightTakeoffIcon;
